<template>
    <div :class="cssClass" v-if="resourceCount > 0" :disabled="isCssDisabled">

        <div class="checkbox-group d-flex align-items-center justify-content-between">
            <div class="d-flex">
                <input type="checkbox" :id="strCheckboxId" name="category-filters[]" :disabled="resourceCount === 0"
                       :value="id" ref="input" v-model="checked"
                       :tabindex="filtersOpen ? 0 : -1"
                       :aria-hidden="!filtersOpen">
                <label :for="strCheckboxId"
                       :aria-hidden="!filtersOpen">{{ title }}<span v-if="resourceCount > 0">({{
                        resourceCount
                    }})</span></label>
            </div>
            <div class="btn-expand-wrapper" v-if="children.length > 0">
                <button class="btn-expand" @click="toggleOpened" :aria-controls=" groupId "
                        :aria-expanded="ariaOpened" :aria-label="getAriaButtonLabel"
                        :tabindex="filtersOpen ? 0 : -1"
                        :aria-hidden="!filtersOpen"
                ></button>
            </div>
        </div>

        <div class="filter-group-container" :id="groupId" ref="filterGroupContainer">
            <filter-group-items
                v-for="(child,index) in children"
                :key="'item' + index"
                :item="child"
                :level="level + 1"
                :group_type="groupType"
                :parent-enabled="resourceCount > 0"
                ref="allFilterGroupItems"
            ></filter-group-items>
        </div>

    </div>

</template>

<script setup>

import { computed, onMounted, ref, watch } from "vue";
import { useStore }                        from "vuex";
import { uniqueId }                        from "lodash-es";

//init
let store = useStore();

//PROPS
let props = defineProps( [ "item", "level", "group_type", "parentEnabled" ] );


let item = props.item;

let level = parseInt( props.level );


//DATA
let children            = item.items ?? [];
let hasChildren         = children && children.length > 0;
let id                  = item.id;
let strCheckboxId       = `category-filter-checkbox_${id}`;
let title               = item.title;
let resources           = item.resources ?? [];
let groupType           = props.group_type;
let allFilterGroupItems = ref( [] );
let input               = ref( null );
let opened              = ref( false );


//COMPUTED/REF
let filteredResults = computed( () => store.getters.filteredResults );
let resourceCount   = computed( () => store.getters.filteredResults.reduce( ( a, r ) => a += (resources.includes( r.id ) ? 1 : 0), 0 ) );

let cssClassHasChildren = ref( (hasChildren ? "has-children " : "") )
let cssClassLevel       = ref( "level_" + parseInt( level ) );
let cssClassOpened      = computed( () => opened.value ? " opened" : " closed" );
let cssClassDisabled    = ref( resourceCount.value === 0 ? " disabled2" : "" );

let cssClass      = computed( () => "filter-group " + cssClassHasChildren.value + cssClassLevel.value + cssClassOpened.value + cssClassDisabled.value );
let isCssDisabled = props.parentEnabled.value && resourceCount.value > 0;

let filtersOpen = computed( () => store.getters.areFiltersOpen );

// a11y
let filterGroupContainer = ref( null );
let groupId              = uniqueId( 'filter-group-' )
let ariaOpened           = computed( () => opened.value );
let getAriaButtonLabel   = computed( () => opened.value ? "Fermer la sous-section" : "Ouvrir la sous-section" );


//GETTER/SETTERS
let checked = computed(
    {
        get ()
        {
            return store.getters.checkedIds.includes( id )
        },
        set ( val )
        {
            changeChecked( val )

        },
    },
);


let debug = computed( () => opened.value ? "opened" : "closed" );


//METHODS
function toggleOpened ()
{
    opened.value = !opened.value;
}

function collapse ()
{
    opened.value = false;
    allFilterGroupItems.value.forEach( item => item.collapse() )

    opened.value = false;

}

function expand ()
{

    opened.value = true;
    allFilterGroupItems.value.forEach( item => item.expand() );

    opened.value = true;
}

function clear ()
{

    if ( checked.value )
    {
        changeChecked( false );

    }

    allFilterGroupItems.value.forEach( item => item.clear() )
}

function changeChecked ( val )
{
    store.commit( "checked", { id, checked : val, type : groupType } );
    store.dispatch( "related" );
}

//WATCH
//watch ( () => checked.value, (newVal, oldVal) =>  changeChecked(newVal));


defineExpose( { collapse, expand, clear, resourceCount } );


</script>

<style scoped>


</style>
